<div class="modal-header">
  <h4 class="modal-title pull-left">
    Upload Image
  </h4>
  <button type="button" class="close" (click)="modalRef.hide()">
    <i class="bi bi-x"></i>
  </button>
</div>
<form class="condition__form credential"
  [formGroup]="galleryForm" 
  #gallery
  (submit)="saveGallery()">
  <div class="modal-body optionsModal__body">
    <div class="vam_show_car_form_container">
      <div class="row mx-n2">
        <div class="col-md-6 px-2">
          <div class="form-group"> 
            <input type="text"
              name="part_name" 
              formControlName="part_name"
              placeholder="Enter title"
              class="form-control credential__input-lg"
              [class.is-invalid]="formData.part_name.invalid && this.submitted">
            </div>
        </div>
        
        <div class="col-md-6 px-2">
          <div class="form-group"> 
            <input type="text"
              name="part_name_arabic" 
              formControlName="part_name_arabic"
              placeholder="Enter Arabic title"
              class="form-control credential__input-lg"
              [class.is-invalid]="formData.part_name_arabic.invalid && this.submitted">
            </div>
        </div>
      </div>

      <div class="row mx-n2">
        <div class="col-12 px-2">
          <div class="form-group"> 
            <label for="part" class="credential__file m-0"> 
              <input type="file"
                name="part" 
                formControlName="part" 
                class="form-conrol d-none" 
                id="part"
                (change)="fileGetter($event)"> 
              <img src="assets/images/car-image_icon.svg" class="conditionFormFilePreview" [hidden]="file"/>
              <p class="fs fs__md" *ngIf="file">
                {{ file.name }}
              </p>
            </label> 
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer conditionModal__footer">
    <div class="conditionModal__footerInner">
      <div class="row w-100 mx-0">
        <div class="col-md-6 mx-auto px-0"> 
          <button type="submit" class="btn btn__primary w-100">Done</button>
        </div>
      </div>
    </div>
  </div>
</form>
